"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = require("./base");

var _noty = babelHelpers.interopRequireDefault(require("noty"));

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var CatalogNavModal =
/*#__PURE__*/
function (_ReactModal) {
  babelHelpers.inherits(CatalogNavModal, _ReactModal);

  function CatalogNavModal(reactElement) {
    var _this;

    babelHelpers.classCallCheck(this, CatalogNavModal);
    _this = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(CatalogNavModal).call(this));
    _this.classList = ['modal', 'fade'];
    _this.innerWrapper = false;
    _this.hasModalTitleElement = false;
    _this.removeOnHide = true;

    _this.setComponent(reactElement);

    return _this;
  }

  return CatalogNavModal;
}(_base.ReactModal); // export default new CatalogNavModal('catalog-mobile-nav');


exports.default = CatalogNavModal;